import { render } from "./CategoriesSectionHome.vue?vue&type=template&id=75b5b588&scoped=true"
import script from "./CategoriesSectionHome.vue?vue&type=script&lang=js"
export * from "./CategoriesSectionHome.vue?vue&type=script&lang=js"

import "./CategoriesSectionHome.vue?vue&type=style&index=0&id=75b5b588&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b5b588"]])

export default __exports__